module.exports = __webpack_public_path__ + "img/puptitle5.f0a09bbd.png";